var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('about-mycolor-base',{staticClass:"p-about-mycolor--pc",attrs:{"tag":_vm.tag}})}
var staticRenderFns = []

export { render, staticRenderFns }